<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EbMWUs/tc-custom/9781426835841.jpg?1738324484289" alt="This image is the cover for the book Mountain Wild"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mountain Wild
      </h1>
      <p class="bookDescription body article font2">
        <b>A beautiful mountain recluse rescues an injured cowboy who could change her life in this captivating historical western romance.</b><br/><br/>Fourteen years ago a terrified young Maggie Grace fled into the wilderness of the Wyoming mountains, where she has lived alone, fighting for survival, ever since. Until she finds cowboy Garret Daines lying unconscious in a blizzard.<br/><br/>Snowbound in Maggie’s cabin, sharing the only bed with this beautiful, wild woman, brings Garret’s body—and guarded heart—pulsing back to life.<br/><br/>Garret is the only man ever to show Maggie any kindness, and the walls around her heart begin to crumble. But this wildcat won’t let herself be easily tamed. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stacey Kayne
      </h2>
      
      <p class="authorDescription body article">Stacey Kayne brings her love of American history to vivid life with stories set in the wild west, featuring heroic women and the men strong enough to love them. Her work has garnered four Golden Heart finals and over sixty regional contest wins, and she was a Romantic Times Reviewer's Choice Award nominee in 2009. Stacey lives on a ranch with her high school sweetheart turned husband of twenty years and their two sons. You can visit her website at: www.staceykayne.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?688e500d